import { Box, Colors, Text } from '@fozito/common-ui';
import { Form } from 'antd';
import FormItemValue from 'components/FormItemValue';
import moment from 'moment';
import styled from 'styled-components';
import { HEIGHT_HEADER } from '../cashier.utils';
import AddNewCustomer from '../Customer/AddCustomer';
import MergeTicket from '../features/Tickets/MergeTicket';
import SplitTicket from '../features/Tickets/SplitTicket';
import StaffClockInOut from '../Staff/StaffClockInOut';

const TicketTop = () => {
  return (
    <Container>
      <FormItemValue
        name={'ticketNumber'}
        render={(val) => (
          <TicketInfo>
            <TicketTag title_h4_24_medium color_text_1>
              #{val}
            </TicketTag>
            <Time>
              <FormItemValue name={'createdDate'} render={(val) => {
                const date = val ? moment(val, 'MM-DD-YYYY hh:mm A') : moment();
                return <>
                  <Text title_h9_18_semibold>{date.format('MM-DD-YYYY')}</Text>
                  <Text title_h9_18_semibold>{date.format('hh:mm A')}</Text>
                </>;
              }} />
            </Time>
          </TicketInfo>
        )}
      />
      <Box display='flex' gap={8}>
        <Box display='flex' flexDirection='column' width={160}>
          <MergeTicket />
          <Form.Item name={'billId'} noStyle>
            <SplitTicket />
          </Form.Item>
        </Box>
        <AddNewCustomer />
        <Form.Item name={'staffId'} noStyle >
          <StaffClockInOut />
        </Form.Item>
      </Box>
    </Container>
  );
};

export default TicketTop;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  padding: 0px 24px;
  height: ${HEIGHT_HEADER}px;
  align-items: center;
  background: #FFF;
  box-shadow: 0px 4px 8px -4px rgba(0, 0, 0, 0.25);
  padding-right: 8px;
`;

const TicketInfo = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  text-align: left;
  flex: 1;
`;

const Time = styled.div`
  display: flex;
  flex-direction: column;
`;

const TicketTag = styled(Text)`
  background-color: ${Colors.neutral.bg[6]};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
`;
